import React from 'react'

export function Loading() {
  const [show, setShow] = React.useState(false)

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      setShow(true)
    }, 500)

    return () => {
      clearTimeout(timeout)
    }
  })

  return (
    <div className='h-100 w-100 d-flex justify-content-center align-items-center'>
      {show && (
        <div className='h2 heavyset'>
          Loading
          <i className='fas fa-spinner fa-spin ml-3' />
        </div>
      )}
    </div>
  )
}

export default Loading
